import Button from "../Button";

const StepFinalDetails = ({

  formData,
  handleInputChange,
  handleDropdownChange,
  handleBack,
  handleStatusSubmit,
  loading,
  clickedStatus,
}) => (
  <>
    {console.log("Form Data in StepFinalDetails:", formData)}
    <div className="text-center">

      <p className="text-sm text-gray-500 mt-1"></p>
    </div>{" "}
    {(formData.created_at || formData.updated_at || formData.updated_by) && (
      <div className="rounded-md border border-gray-200 bg-gray-50 p-3 text-xs text-gray-600 grid grid-cols-1 sm:grid-cols-3 gap-2">
        {formData.created_at && (
          <div>
            <span className="font-semibold text-gray-700">Created At:</span>{" "}
            {new Date(formData.created_at).toLocaleString()}
          </div>
        )}
        {formData.updated_at && (
          <div>
            <span className="font-semibold text-gray-700">Updated At:</span>{" "}
            {new Date(formData.updated_at).toLocaleString()}
          </div>
        )}
        {formData.updated_by && (
          <div>
            <span className="font-semibold text-gray-700">Updated By:</span>{" "}
            {formData.updated_by}
          </div>
        )}
      </div>
    )}
    <div className="space-y-4">



      <div>
        <label className="block text-sm font-medium text-gray-700">
          Tile Type (Card Layout)
        </label>
        <select
          name="tileType"
          value={formData.tileType || ""}
          onChange={handleInputChange}
          className="mt-1 block w-full py-2 px-4 border rounded-md border-gray-300 shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
        >
          <option value="type1">Type 1</option>
          <option value="">Normal Image Card</option>
          <option value="text_card">Text Card</option>
          <option value="title_card">Title Card</option>
        </select>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700">
          Type (Behaviour)
        </label>
        <select
          name="type"
          value={formData.type || ""}
          onChange={handleInputChange}
          className="mt-1 block w-full py-2 px-4 border rounded-md border-gray-300 shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
        >
          {/* <option value="">None</option> */}
          <option value="START">START</option>
          <option value="type1">Type 1</option>
        </select>
      </div>



      {/* Start Index */}
      <div>
        <label className="block text-sm font-medium text-gray-700">
          Start Index
        </label>
        <input
          type="number"
          name="startIndex"
          value={formData.startIndex}
          className="mt-1 block w-full py-2 px-4 border rounded-md border-gray-300 shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          onChange={handleInputChange}
        />
      </div>
      {/* Alternate URL */}
      <div>
        <label className="block text-sm font-medium text-gray-700">
          Alternate URL
        </label>
        <input
          type="text"
          name="alternateUrl"
          value={formData.alternateUrl}
          className="mt-1 block w-full py-2 px-4 border rounded-md border-gray-300 shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          placeholder="Enter alternate URL"
          onChange={handleInputChange}
        />
      </div>


      {/* Playstore URL */}
      <div>
        <label className="block text-sm font-medium text-gray-700">
          Playstore URL
        </label>
        <input
          type="text"
          name="playstoreUrl"
          value={formData.playstoreUrl || ""}
          className="mt-1 block w-full py-2 px-4 border rounded-md border-gray-300 shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          placeholder="Enter Playstore URL"
          onChange={handleInputChange}
        />
      </div>

      {/* Package Name */}
      <div>
        <label className="block text-sm font-medium text-gray-700">
          Package Name
        </label>
        <input
          type="text"
          name="package"
          value={formData.package || ""}
          className="mt-1 block w-full py-2 px-4 border rounded-md border-gray-300 shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          placeholder="com.example.app"
          onChange={handleInputChange}
        />
      </div>

      {/* Tile Dimensions */}
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Tile Width (px)
          </label>
          <input
            type="number"
            name="tileWidth"
            value={formData.tileWidth || ""}
            className="mt-1 block w-full py-2 px-4 border rounded-md border-gray-300 shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            placeholder="e.g. 300"
            onChange={handleInputChange}
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Tile Height (px)
          </label>
          <input
            type="number"
            name="tileHeight"
            value={formData.tileHeight || ""}
            className="mt-1 block w-full py-2 px-4 border rounded-md border-gray-300 shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            placeholder="e.g. 300"
            onChange={handleInputChange}
          />
        </div>
      </div>





    </div>
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <div className="flex  flex-col gap-4">
        {/* Use Alternate */}
        <div className="flex items-center justify-between">
          <label
            htmlFor="useAlternate"
            className="block cursor-pointer text-sm font-medium text-gray-700 flex-1 text-left pr-4"
          >
            Use Alternate :
          </label>
          <input
            id="useAlternate"
            type="checkbox"
            name="useAlternate"
            className="mt-1"
            checked={formData.useAlternate}
            onChange={handleInputChange}
          />
        </div>

        {/* Show Tile Info */}
        <div className="flex items-center justify-between">
          <label
            htmlFor="showTileInfo"
            className="block cursor-pointer text-sm font-medium text-gray-700 flex-1 text-left pr-4"
          >
            Show Tile Info :
          </label>
          <input
            id="showTileInfo"
            type="checkbox"
            name="showTileInfo"
            className="mt-1"
            checked={formData.showTileInfo}
            onChange={handleInputChange}
          />
        </div>

        {/* Detail Page */}
        <div className="flex items-center justify-between">
          <label
            htmlFor="detailPage"
            className="block cursor-pointer text-sm font-medium text-gray-700 flex-1 text-left pr-4"
          >
            Show Detail Page :
          </label>
          <input
            id="detailPage"
            type="checkbox"
            name="detailPage"
            className="mt-1"
            checked={formData.detailPage}
            onChange={handleInputChange}
          />
        </div>
      </div>
    </div>

    {/* Status Submit Buttons */}
    <div className="sticky bottom-0 z-20 mt-4 -mx-6 px-6 py-3 grid grid-cols-2 sm:grid-cols-4 gap-3">
      {[
        {
          status: "Published",
          color: "bg-green-600 hover:bg-green-700",
        },
        { status: "Unpublished", color: "bg-red-600 hover:bg-red-700" },
        {
          status: "Universe",
          color: "bg-purple-600 hover:bg-purple-700",
        },
        {
          status: "Draft Universe",
          color: "bg-yellow-500 hover:bg-yellow-600 text-black",
        },
      ].map(({ status, color }) => (
        <button
          key={status}
          type="button"
          onClick={handleStatusSubmit(status)}
          disabled={loading}
          className={`${color} py-2 px-4 rounded-md font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-offset-1 ${clickedStatus === status ? "ring-2 ring-black" : ""
            }`}
        >
          {clickedStatus === status && loading ? "Saving..." : status}
        </button>
      ))}
    </div>
  </>
);

export default StepFinalDetails;
